import React from 'react'
import { AutocompleteAjaxSeeker } from '@ui-seeker/core'
import { BACKEND_APIS } from '@constants'
import { useAppFormHandler } from '@hooks'


export default function AirConditionSelector() {

	const { airCondition, onAirConditionChange } = useAppFormHandler('airCondition')

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Air Condition"
		placeholder="Any Air Condition"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/air-condition`}
		value={airCondition}
		onChange={e => onAirConditionChange(e.target.value)}
	/>
}